// Password page controls: email/password view toggle and background video buttons.
// Markup lives in sections/main-password.liquid; buttons are wired by data-password-action.
(function () {
  const FADE_MS = 800; // matches .password-view transition in main-password.liquid

  function setVisible(view, visible) {
    view.classList.toggle('is-hidden', !visible);
  }

  function toggleView(button) {
    const capture = document.getElementById('password-capture-container');
    const form = document.getElementById('password-form-container');
    const label = button.querySelector('[data-label]');
    if (!capture || !form) return;

    const showingCapture = !capture.classList.contains('is-hidden');
    const outgoing = showingCapture ? capture : form;
    const incoming = showingCapture ? form : capture;

    // Fade the current view out fully before fading the other in.
    setVisible(outgoing, false);
    setTimeout(() => {
      setVisible(incoming, true);
      if (label) label.textContent = showingCapture ? 'Enter Email' : 'Enter Password';
    }, FADE_MS);
  }

  function togglePlay(button) {
    const video = document.getElementById('password-video');
    const label = button.querySelector('[data-label]');
    if (!video) return;

    if (video.paused) {
      video.play();
      if (label) label.textContent = 'Pause';
    } else {
      video.pause();
      if (label) label.textContent = 'Play';
    }
  }

  function toggleMute(button) {
    const video = document.getElementById('password-video');
    const label = button.querySelector('[data-label]');
    if (!video) return;

    video.muted = !video.muted;
    if (label) label.textContent = video.muted ? 'Unmute' : 'Mute';
  }

  const mobile = window.matchMedia('(max-width: 767px)');

  function selectContents(node) {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(node);
    selection.removeAllRanges();
    selection.addRange(range);
  }

  // Footer email links. Desktop: the label swaps for the address in place.
  // Mobile: the address shows on its own line above the links, so the row never reflows;
  // tapping the active link again hides it.
  function revealEmail(button) {
    const email = button.dataset.email;
    const label = button.querySelector('[data-label]');
    if (!email || !label) return;

    const line = document.querySelector('.password-reveal-line');
    if (mobile.matches && line) {
      const isActive = button.classList.contains('is-active');
      document.querySelectorAll('.password-reveal-link.is-active').forEach((el) => el.classList.remove('is-active'));

      if (isActive) {
        line.hidden = true;
        line.textContent = '';
        window.getSelection().removeAllRanges();
        return;
      }

      button.classList.add('is-active');
      line.textContent = email;
      line.hidden = false;
      selectContents(line);
      return;
    }

    if (!button.classList.contains('is-revealed')) {
      label.textContent = email;
      button.classList.add('is-revealed');
    }
    selectContents(label);
  }

  const actions = {
    'toggle-view': toggleView,
    'toggle-play': togglePlay,
    'toggle-mute': toggleMute,
    'reveal-email': revealEmail,
  };

  // Klaviyo draws into any .klaviyo-form-<id> div, including ones added after load. The div is only
  // created once Vue has mounted #app (see main-password.liquid), or straight away when there is no Vue.
  const KLAVIYO_WAIT_MS = 5000;

  function mountKlaviyoForm() {
    document.querySelectorAll('[data-klaviyo-form]').forEach((slot) => {
      if (slot.querySelector('[class^="klaviyo-form-"]')) return;
      const form = document.createElement('div');
      form.className = `klaviyo-form-${slot.dataset.klaviyoForm}`;
      slot.appendChild(form);
    });
  }

  const started = performance.now();
  (function waitForVue() {
    const app = document.getElementById('app');
    if (!app || app.__vue_app__ || performance.now() - started > KLAVIYO_WAIT_MS) {
      mountKlaviyoForm();
      return;
    }
    requestAnimationFrame(waitForVue);
  })();

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-password-action]');
    if (!button) return;
    const action = actions[button.dataset.passwordAction];
    if (action) action(button);
  });
})();
